import React, { useLayoutEffect, useRef, useState } from 'react'
import { Box, Button, Typography } from '@mui/material'
import FormattedDescription from '@/housefolios-components/shared/FormattedDescription'

/**
 * Truncates long text with a Read more / Read less toggle.
 * Uses max-height so paragraphs and bullet lists clamp cleanly.
 */
function ExpandableText({
  text,
  maxLines = 4,
  emptyLabel = 'No description included',
  align = 'left',
  sx,
}) {
  const [expanded, setExpanded] = useState(false)
  const [needsClamp, setNeedsClamp] = useState(false)
  const textRef = useRef(null)
  const lineHeight = 1.6

  useLayoutEffect(() => {
    if (expanded) return
    const el = textRef.current
    if (!el) return
    setNeedsClamp(el.scrollHeight > el.clientHeight + 1)
  }, [text, expanded, maxLines])

  if (!text) {
    return (
      <Typography
        align={align}
        color="text.secondary"
        sx={{ px: 2, py: 1.5 }}
      >
        {emptyLabel}
      </Typography>
    )
  }

  return (
    <Box sx={[{ px: 2, py: 1.5, width: '100%' }, sx]}>
      <Box
        ref={textRef}
        sx={{
          ...(!expanded && {
            maxHeight: `${maxLines * lineHeight}em`,
            overflow: 'hidden',
          }),
        }}
      >
        <FormattedDescription text={text} align={align} />
      </Box>
      {(needsClamp || expanded) && (
        <Button
          size="small"
          color="primary"
          onClick={() => setExpanded((prev) => !prev)}
          sx={{
            mt: 0.5,
            px: 0,
            minWidth: 0,
            textTransform: 'none',
            fontWeight: 600,
          }}
        >
          {expanded ? 'Read less' : 'Read more'}
        </Button>
      )}
    </Box>
  )
}

export default ExpandableText
